import React from 'react';
import styled from 'styled-components';
import { mediaQueries } from '../styles/mediaQueries';

import Loader from './Loader';
import { isPlainView } from '../helpers/plainViewHelper';
import { isNativeApp } from '../helpers/nativeAppHelper';

export interface PageContentProps {
  children: React.ReactNode;
  isLoading?: boolean;
  view?: string;
}

interface StyledContentProps {
  $withStickyFooter: boolean;
}

const Content = styled.div<StyledContentProps>`
  padding: 0 1rem;
  display: block;
  margin-bottom: ${(props) => (props.$withStickyFooter ? '0' : '6rem')};

  ${(props) =>
    props.$withStickyFooter &&
    `
    display: flex;
    flex-direction: column;
    flex-grow: 1;    
  `}

  ${mediaQueries.desktopUp} {
    padding: 0;
    margin-bottom: ${(props) => (props.$withStickyFooter ? '0' : '4rem')};
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 272px;
`;

const PageContent: React.FunctionComponent<PageContentProps> = ({
  children,
  isLoading = false,
  view,
}): JSX.Element => {
  if (isLoading) {
    return (
      <LoadingContainer>
        <Loader />
      </LoadingContainer>
    );
  }

  return (
    <Content
      $withStickyFooter={
        view === 'plain' || isPlainView() || isNativeApp() || view === 'native'
      }
    >
      {children}
    </Content>
  );
};

export default PageContent;
